export default __webpack_public_path__ + "static/media/Avatar-25.2a55c0c8.png";